const positions = [
  {
    label: "President",
    value: "president",
  },
  {
    label: "Vice President",
    value: "vice",
  },
  {
    label: "Secretary",
    value: "secretary",
  },
  {
    label: "Treasurer",
    value: "treasurer",
  },
  {
    label: "Board Member",
    value: "board",
  },
]

export default positions
